module.exports = __webpack_public_path__ + "static/media/birdbrain_1024X768.2751157b.jpg";